import { render, staticRenderFns } from "./workerData.vue?vue&type=template&id=0e339fd0&"
import script from "./workerData.vue?vue&type=script&lang=js&"
export * from "./workerData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports